<app-bootstrap-input-phone *ngIf="isType('phone')" [inputConfig]="inputConfig"></app-bootstrap-input-phone>
<app-bootstrap-input-text *ngIf="isType('text')" [inputConfig]="inputConfig"></app-bootstrap-input-text>
<app-bootstrap-input-email *ngIf="isType('email')" [inputConfig]="inputConfig"></app-bootstrap-input-email>
<app-bootstrap-select *ngIf="isType('select')" [inputConfig]="inputConfig"></app-bootstrap-select>
